import { caseColumns } from "@/types/caseColumns"
import { CaseDetails, CalculationType } from "@/types"

import moment from "moment"
import { TimeSpentAsValue } from "@/types/timeSpentAsValue"
import { formatDateMixin } from "@/mixins/formatDateMixin"

export const calculatedValueDisplay = {
	methods: {

		displayCalculatedField (fieldCase: CaseDetails, fieldExtensions: any, value: any, forCsv = false): string {
			if (fieldExtensions && fieldExtensions.calculationType === CalculationType.AddToDate) {
				let fieldValue = value
				if (fieldValue === null) {
					const sourceField = fieldCase.fields[fieldExtensions.dateField]
					let value = sourceField ? sourceField.value : null

					let dynamic = 0

					if (!sourceField) {
						const caseAsAny = fieldCase as any
						if (caseAsAny[fieldExtensions.dateField]) {
							value = caseAsAny[fieldExtensions.dateField]
						}
					}

					if (value === null) {
						if (sourceField) {
							return sourceField.field.title + " not set"
						}

						const caseColumn = caseColumns.find(c => c.key === fieldExtensions.dateField)
						return caseColumn
							? caseColumn.label + " not set"
							: "Not set"
					}

					if (fieldExtensions.add) {
						fieldExtensions.add.forEach((fieldId: string) => {
							const field = fieldCase.fields[fieldId]
							if (field && field.value && !isNaN(field.value)) {
								dynamic += parseInt(field.value)
							}
						})
					}

					const staticAddition = fieldExtensions.static ? parseInt(fieldExtensions.static) : 0

					const dateTime: Date = new Date(value)
					dateTime.setDate(dateTime.getDate() + staticAddition + dynamic)
					fieldValue = dateTime
				}

				const valueMoment = moment(fieldValue)

				if (fieldExtensions.showTime) {
					return valueMoment.format("L LT")
				} else {
					return valueMoment.format("L")
				}
			} else if (fieldExtensions && fieldExtensions.calculationType === CalculationType.DaysUntilOrFromToday) {
				if (fieldExtensions.dateField) {
					let days = value
					if (value === null || value === undefined) {
						const sourceField = fieldCase.fields[fieldExtensions.dateField]
						let fieldValue = sourceField ? sourceField.value : null

						if (!sourceField) {
							const caseAsAny = fieldCase as any
							if (caseAsAny[fieldExtensions.dateField]) {
								fieldValue = caseAsAny[fieldExtensions.dateField]
							}
						}

						if (!fieldValue) {
							return ""
						}

						days = this.localWholeDaysFromToday(fieldValue)
					}
					if (days === 0) {
						return "Today"
					} else if (days === -1) {
						return "Tomorrow"
					} else if (days === 1) {
						return "Yesterday"
					} else if (days < 0) {
						return `In ${-days} days`
					} else {
						return `${days} days ago`
					}
				}
			} else if (fieldExtensions && fieldExtensions.calculationType === CalculationType.DaysBetweenDates) {
				if (value === null || value === undefined) {
					const startValue = calculatedValueDisplay.methods.getFieldValue(fieldCase, fieldExtensions.startField)
					const endValue = calculatedValueDisplay.methods.getFieldValue(fieldCase, fieldExtensions.endField)

					if (startValue && endValue) {
						const startDate: Date = new Date(startValue)
						const endDate: Date = new Date(endValue)

						const timeDifference = endDate.getTime() - startDate.getTime()
						return Math.floor(timeDifference / (1000 * 60 * 60 * 24)).toString()
					}
				}
			} else if (fieldExtensions && fieldExtensions.calculationType === CalculationType.TimeSpentAs) {
				if (value === null || value === undefined) {
					return "No entries recorded"
				}

				const timeSpentValue = value as TimeSpentAsValue

				if (timeSpentValue.totals.length === 0) {
					return "No entries recorded"
				}

				const timeSpentStrings = timeSpentValue.totals.map(c => `${c.fieldValue ? c.fieldValue : "Not Set"}: ${formatDateMixin.methods.timeSpentFormatted(c.hoursSpent)}`)

				const formattedResult = forCsv ? timeSpentStrings.join("; ") : timeSpentStrings.join("\n")

				return formattedResult
			}
			return value as string
		},
		localWholeDaysFromToday (fieldValue: any) : number {
			const fieldValueDate = moment(new Date(fieldValue)).startOf("day") // the date part of the field value, in local time
			const todaysDate = moment().startOf("day") // today's date, in local time

			// the whole number of days difference
			return todaysDate.diff(fieldValueDate, "days")
		},
		localDaysFromToday (fieldValue: any) : number {
			const fieldValueDateTime = moment(new Date(fieldValue))
			const todaysDate = moment().startOf("day") // today's date, in local time

			// the fractional number of days difference
			return todaysDate.diff(fieldValueDateTime, "days", true)
		},

		getFieldValue (fieldCase: CaseDetails, fieldKey: string) : any {
			const field = fieldCase.fields[fieldKey]
			const caseAsAny = fieldCase as any
			let fieldValue = field ? field.value : null
			if (!field) {
				if (caseAsAny[fieldKey]) {
					fieldValue = caseAsAny[fieldKey]
				}
			}
			return fieldValue
		}
	}
}
